import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomDataset,
  BackendMutationPerformanceCenterCreateBlogUrlCustomModelArgs,
} from 'src/types/backend';

import { CUSTOM_DATASET_FRAGMENT } from '../customModel/schema';

const MUTATION = gql`
  mutation performanceCenterCreateBlogUrlCustomModel(
    $customerId: ID!
    $name: String!
    $brandVoiceId: ID!
    $accountIds: [ID!]!
    $dataSource: PerformanceCenterDataSource!
  ) {
    performanceCenterCreateBlogUrlCustomModel(
      customerId: $customerId
      name: $name
      brandVoiceId: $brandVoiceId
      accountIds: $accountIds
      dataSource: $dataSource
    ) {
      ...CustomDataset
    }
  }
  ${CUSTOM_DATASET_FRAGMENT}
`;

type Variables = BackendMutationPerformanceCenterCreateBlogUrlCustomModelArgs;
type Result = BackendCustomDataset;

export const performanceCenterCreateBlogUrlCustomModel = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
